import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "content-card contact-card",
  "data-sidebar-card": ""
}
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = { class: "flow" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  class: "highlighted-content-text",
  "data-neutral": ""
}
const _hoisted_6 = {
  class: "callout",
  "data-borderless": "",
  "data-neutral": ""
}
const _hoisted_7 = {
  class: "icon-text",
  "data-small-heading": ""
}
const _hoisted_8 = {
  class: "icon-text__icon highlighted-icon",
  "aria-hidden": "true"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  class: "icon-text",
  "data-small-heading": ""
}
const _hoisted_11 = {
  class: "icon-text__icon highlighted-icon",
  "aria-hidden": "true"
}
const _hoisted_12 = ["href"]

import PhoneIcon from '@src/components/shared/icons/PhoneIcon.vue';
import MailIcon from '@src/components/shared/icons/MailIcon.vue';

interface Props {
	assetsPath: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTeamContact',
  props: {
    assetsPath: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t( 'contact_sidebar_title' )), 1),
      _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: __props.assetsPath + '/images/contact-team.png',
        alt: _ctx.$t( 'contact_sidebar_image_alt' )
      }, null, 8, _hoisted_4),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t( 'contact_sidebar_subtitle' )), 1),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.$t( 'contact_sidebar_opening' )), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(PhoneIcon)
          ]),
          _createElementVNode("a", {
            href: `tel:${ _ctx.$t( 'contact_sidebar_phone' ) }`
          }, _toDisplayString(_ctx.$t( 'contact_sidebar_phone' )), 9, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(MailIcon)
          ]),
          _createElementVNode("a", {
            href: `mailto:${ _ctx.$t( 'contact_sidebar_email' ) }`
          }, _toDisplayString(_ctx.$t( 'contact_sidebar_email' )), 9, _hoisted_12)
        ])
      ])
    ])
  ]))
}
}

})